import config from "@/../config";
import http from "@/api/http";

export default {
  getEjemplo(params, data, onSuccess, onError) {
    return http
      .get(
        `${config.host}/${config.version}/reportes3/reporte_global/${data}?${params}`
      )
      .then(onSuccess)
      .catch(onError);
  },
  getModelos(onSuccess, onError) {
    return http
      .get(`${config.host}/${config.version}/reportes3/modelos`)
      .then(onSuccess)
      .catch(onError);
  }
};
